import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './index.css'; // Make sure this file has your styles

const Special = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false,
    });
  }, []);

  return (
    <div className="khushiyo-bhari">
      <img
        className="desk-banner"
        src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1744892215/Frame_38_fywfde.png"
        alt="Desktop Banner"
      />
      <img
        className="mob-banner"
        src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1744183746/01-_1_sxqh3e.png"
        alt="Mobile Banner"
      />

      <div className="toffee1 tf" data-aos="fade-up" data-aos-delay="100">
        <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1744004303/2_1_bbchbz.png" alt="" />
      </div>
      <div className="toffee2 tf" data-aos="fade-up" data-aos-delay="300">
        <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1744004303/3_1_fczpkq.png" alt="" />
      </div>
      <div className="toffee3 tf" data-aos="fade-up" data-aos-delay="500">
        <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1744004303/4_1_vnx9if.png" alt="" />
      </div>
      <div className="toffee4 tf" data-aos="fade-up" data-aos-delay="700">
        <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1744004304/8_1_f9ftep.png" alt="" />
      </div>
      <div className="toffee5 tf" data-aos="fade-up" data-aos-delay="900">
        <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1744004303/5_1_u14kh1.png" alt="" />
      </div>
      <div className="toffee6 tf" data-aos="fade-up" data-aos-delay="1100">
        <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1744004306/6_1_xdzcr1.png" alt="" />
      </div>
      <div className="toffee7 tf" data-aos="fade-up" data-aos-delay="1300">
        <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1744004305/7_1_swcqv6.png" alt="" />
      </div>
    </div>
  );
};

export default Special;